import React from 'react';

interface PhoneMockupProps {
  screenshotSrc: string;
  index: number;
}

const PhoneMockup: React.FC<PhoneMockupProps> = ({ screenshotSrc, index }) => {
  return (
    <div className="w-full h-full flex items-center justify-center p-2">
      {/* Phone frame - no background on the container */}
      <div className="relative w-[280px] h-[560px] rounded-[40px] bg-gray-900 p-3.5">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1/3 h-8 bg-gray-900 rounded-b-xl z-10"></div>
        
        {/* Screen */}
        <div className="w-full h-full rounded-[32px] overflow-hidden bg-white relative">
          {/* Screenshot image */}
          <img 
            src={screenshotSrc} 
            alt={`App screenshot ${index + 1}`} 
            className="w-full h-full object-cover"
          />
          
          {/* Status bar */}
          <div className="absolute top-0 left-0 right-0 h-8 px-5 flex justify-between items-center">
            <div className="text-sm font-medium text-white/80">9:41</div>
            <div className="flex space-x-1.5">
              <div className="w-5 h-3.5 bg-white/80 rounded-sm"></div>
              <div className="w-3.5 h-3.5 bg-white/80 rounded-full"></div>
              <div className="w-3.5 h-3.5 bg-white/80 rounded-full"></div>
            </div>
          </div>
        </div>
        
        {/* Home indicator */}
        <div className="absolute bottom-1.5 left-1/2 transform -translate-x-1/2 w-1/3 h-1.5 bg-gray-600 rounded-full"></div>
      </div>
    </div>
  );
};

export default PhoneMockup;
